

module.exports = __webpack_require__.stylable.create(
    "Validity2894045139",
    {"classes":{"root":"Validity2894045139__root","duration":"Validity2894045139__duration"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Validity2894045139",
    null
);
